import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/roles`)
  return data.data
}

export const useRoles = () => {
  const { data, ...props } = useQuery(
    queryKeys.ROLES,
    () => getData(),
  )
  return { data, ...props }
}
